import { render, staticRenderFns } from "./TableMedien.vue?vue&type=template&id=068fed5e&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TableMedien.vue?vue&type=script&lang=js"
export * from "./TableMedien.vue?vue&type=script&lang=js"
import style0 from "./TableMedien.vue?vue&type=style&index=0&id=068fed5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fed5e",
  null
  
)

export default component.exports